import {
  Info,
  Award,
  Briefcase,
  Archive,
  Disc,
  BookOpen,
  UserCheck,
  Mail,
  Columns,
  Users,
  Clipboard,
  BarChart2,
  Globe,
  User,
  Box,
  Hash,
  Wifi,
} from "react-feather";

const adminSection = [
  {
    href: "/student",
    icon: Info,
    title: "Dashboard",
  },
  {
    href: "/student/results",
    icon: BarChart2,
    title: "Academic Results",
  },
  {
    href: "/student/rewards",
    icon: Award,
    title: "Rewards & Punishments",
  },
  {
    href: "/student/curriculum",
    icon: BookOpen,
    title: "My Curriculum & Notes",
  },
  {
    href: "/student/attendance",
    icon: UserCheck,
    title: "Attendance",
  },
  {
    href: "/student/news",
    icon: Mail,
    title: "News & Announcements",
  },
  {
    href: "/student/my-school",
    icon: Briefcase,
    title: "My School",
  },
];

const broadcastingSection = [
  {
    href: "/student/broadcast/srd-device",
    title: "SRD Device  ",
    icon: Box,
  },
  {
    href: "/student/broadcast/streaming",
    title: "Streaming",
    icon: Wifi,
  },
  {
    href: "/student/broadcast/ussd",
    title: "USSD",
    icon: Hash,
  },
];
const settingsSection = [
  {
    href: "/student/profile",
    icon: User,
    title: "My Information",
  },
  {
    href: "/student/language",
    icon: Globe,
    title: "Languages",
  },
  {
    href: "/student/accessibility",
    icon: Disc,
    title: "Accessibility",
  },
];

const navItems = [
  {
    title: "Navigation",
    pages: adminSection,
  },
  {
    title: "Broadcasting",
    pages: broadcastingSection,
  },
  {
    title: "Settings",
    pages: settingsSection,
  },
];

export default navItems;
